import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const MSG = "Ti piace la FIGAAAAAAAAAA?";
const STORAGE_KEY = "adminRandomToast";
const MIN_PER_DAY = 14;
const MAX_PER_DAY = 15;

const START_H = 7;
const END_H = 20;

function planForToday() {
  const now = new Date();
  const dayKey = now.toISOString().slice(0, 10);
  let stored;
  try { stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null"); } catch { stored = null; }
  if (stored && stored.day === dayKey) return stored;

  const count = MIN_PER_DAY + Math.floor(Math.random() * (MAX_PER_DAY - MIN_PER_DAY + 1));
  const times = [];
  for (let i = 0; i < count; i++) {
    const h = START_H + Math.floor(Math.random() * (END_H - START_H));
    const m = Math.floor(Math.random() * 60);
    const t = new Date(now);
    t.setHours(h, m, 0, 0);
    times.push(t.getTime());
  }
  times.sort((a, b) => a - b);
  const plan = { day: dayKey, times, shown: [] };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(plan));
  return plan;
}

export function RandomAdminToast() {
  const { user } = useAuth();

  useEffect(() => {
    if (user?.role !== "admin") return;
    const tick = () => {
      const plan = planForToday();
      const now = Date.now();
      const due = plan.times.filter((t) => t <= now && !plan.shown.includes(t));
      if (due.length) {
        toast(MSG, { duration: 300 });
        plan.shown = [...plan.shown, ...due];
        localStorage.setItem(STORAGE_KEY, JSON.stringify(plan));
      }
    };
    tick();
    const id = setInterval(tick, 60 * 1000);
    return () => clearInterval(id);
  }, [user?.role]);

  return null;
}
